import f from "../funcs";
import Events from "../classes/Events";
import $ from "jquery";
import "css!plugins/cam-style.css";


let getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
let vendorUrl = window.URL || window.webkitURL;
// thanks mdn, HTMLCanvasElement.prototype.toBlob polyfill
// hmm maybe slooow....
let toBlob = function(src, type, callback) {
    let binStr = atob(src.split(",")[1]);


    let len = binStr.length;


    let partLen = 1000;


    let arr = new Uint8Array(len);

    function ayncPart(i, n) {
        for (; i < n; i++) {
            arr[i] = binStr.charCodeAt(i);
        }

        if ( i < len ) {
            let newLen = Math.min(len, i + partLen);
            setTimeout(function() {
                ayncPart(i, newLen);
            }, 5);
        } else {
            callback(new Blob( [arr], { type: type || "image/png" } ));
        }
    }

    ayncPart(0, Math.min(len, partLen));
};

$.fn.cam = function(params) {
    return this.each(function() {
        let $el = $(this);
        $el.data("cam", new Cam(params, $el));
    });
};

let Cam = f.CreateClass("Cam", {}, Events);

Cam.prototype.init = function(params, $box) {
    params = $.extend({
    }, params);

    this.$box = $box;
    this.box = $box[0];

    let rect = this.box.getBoundingClientRect();
    this.width = rect.width;
    this.height = rect.height;

    this.$box.css({
        position: "relative"
    });

    this.initVideo();
    this.initCanvas();

    this.$imgBox = $("<div class='CamPlugin-image'></div>").appendTo(this.$box);
    this.imageBox = this.$imgBox[0];
    this.$imgBox.hide();
};

Cam.prototype.updateSize = function(/* width, height */) {
    let rect = this.box.getBoundingClientRect();
    this.width = rect.width;
    this.height = rect.height;

    this.$video.css({
        width: this.width + "px",
        height: this.height + "px"
    });
};

Cam.prototype.initVideo = function() {
    let video = document.createElement("video");


    let $video = $(video);

    video.className = "CamPlugin-video";

    $video.appendTo(this.$box);
    this.$video = $video;
    this.video = video;

    this.$video.css({
        width: this.width + "px",
        height: this.height + "px"
    });

    this.video.onloadeddata = function() {
        this.trigger("play");
    }.bind(this);
};

Cam.prototype.initCanvas = function() {
    let canvas = document.createElement("canvas");


    let $canvas = $(canvas);

    canvas.className = "CamPlugin-canvas";

    $canvas.appendTo(this.$box);
    this.$canvas = $canvas;
    this.canvas = canvas;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.context = this.canvas.getContext("2d");

    this.$canvas.css({
        width: this.width + "px",
        height: this.height + "px",
        visibility: "hidden"
    });
};

Cam.prototype.play = function() {
    this.$imgBox.hide();
    this.$video.show();

    // не будем мучать юзера с повторным запросом камеры
    if ( this.stream ) {
        this.onMediaStream(this.stream);
        return;
    }

    getMedia.call(navigator,
        {
            video: true,
            audio: false
        },
        this.onMediaStream.bind(this),
        this.onMediaError.bind(this)
    );
};

Cam.prototype.pause = function() {
    this.video.pause();
};

Cam.prototype.onMediaStream = function(stream) {
    let video = this.video;
    video.src = vendorUrl.createObjectURL(stream);
    video.play();
    this.stream = stream;
    this.trigger("stream", stream);
};

Cam.prototype.onMediaError = function(error) {
    this.trigger("error", error);
};

Cam.prototype.mathFrame = function(width, height, x, y, scale) {
    let frame = {};
    let resolution = this.getResolution();

    width = +width || resolution.width;
    height = +height || resolution.height;
    x = +x || 0;
    y = +y || 0;
    scale = +scale || 1;

    frame.x = -x;
    frame.y = -y;
    frame.width = width * scale;
    frame.height = height * scale;

    return frame;
};

Cam.prototype.capture = function(crop) {
    let resolution = this.getResolution();
    // crop внутри camera resolution
    crop.top;
    crop.left;
    crop.width;
    crop.height;
    // во сколько раз масштабировать изображение
    crop.scale;
    // размер изображения на выходе
    let outWidth = crop.outWidth || (crop.width * crop.scale);


    let outHeight = crop.outHeight || (crop.height * crop.scale);

    let x = -crop.left * crop.scale;


    let y = -crop.top * crop.scale;

    let width = resolution.width * crop.scale;


    let height = resolution.height * crop.scale;

    this.canvas.width = outWidth;
    this.canvas.height = outHeight;
    this.context.drawImage(
        this.video,
        x, y,
        width, height
    );

    let src = this.canvas.toDataURL("image/png");
    this.trigger("captureBegin", src);

    toBlob(src, "image/png", function(blob) {
        let capture = {
            src,
            blob,
            width: outWidth,
            height: outHeight,
            img: new Image()
        };

        capture.img.onload = function() {
            capture.img.onload = null;
            this.trigger("capture", capture);
        }.bind(this);
        capture.img.src = src;
    }.bind(this));
};

Cam.prototype.showCapture = function(capture) {
    this.imageBox.innerHTML = "";
    this.imageBox.appendChild(capture.img);
    this.$imgBox.show();
    this.$video.hide();
};

// размер картинки, что видит пользователь
Cam.prototype.getVideoInnerRect = function() {
    // разрешение камеры
    let camWidth = this.video.videoWidth;


    let camHeight = this.video.videoHeight;

    // размер контейнера
    let width = this.width;


    let height = this.height;

    let rect = {
        width,
        height,
        left: 0,
        top: 0
    };

    let camRatio = camWidth / camHeight;


    let ratio = width / height;

    if ( ratio < camRatio ) {
        rect.height = width / camRatio;
        rect.top = (height - rect.height) / 2;
    } else {
        rect.width = height * camRatio;
        rect.left = (width - rect.width) / 2;
    }

    return rect;
};

Cam.prototype.getResolution = function() {
    return {
        width: this.video.videoWidth,
        height: this.video.videoHeight
    };
};

export default Cam;
